export default {"src":"/_next/static/media/help.8de62da2.svg","height":21,"width":22};